// const BuyGroupIndex= () =>import('@/components/buygroup/BuyGroupIndex')
// const BuyGroupOrderList= () =>import('@/components/buygroup/BuyGroupOrderList')
// const BuyGroupOrder= () =>import('@/components/buygroup/BuyGroupOrder')
// const PaySuccess= () =>import('@/components/buygroup/PaySuccess')
// const BuyGroupOrderShare= () =>import('@/components/buygroup/BuyGroupOrderShare')
const LoginBottom= () =>import('@/components/base/LoginBottom')

const LuckPrizeIndex = () =>import('@/components/activityluckprize/Index')
// const ActivityGift = () =>import('@/components/activitygift/Index')
// const ActivityPrize = () =>import('@/components/activityprize/Index')
// const ActivityAddress = () =>import('@/components/activityprize/Address')
export default[

    {
        path: '/luck_prize/index',
        component: LuckPrizeIndex,
        meta: {title: '活动网页,加载中'}
    },
    // {
    //     path: '/activity_gift',
    //     component: ActivityGift,
    //     meta: {title: '加载中...'}
    // },
    // {
    //     path: '/activity_prize',
    //     component: ActivityPrize,
    //     meta: {title: '加载中...'}
    // },
    // {
    //     path: '/activity_address',
    //     component: ActivityAddress,
    //     meta: {title: '加载中...'}
    // }
]




// WEBPACK FOOTER //
// ./src/router/luckprizeRouter.js